import {Pipe, PipeTransform} from '@angular/core';

import {DataAttribute} from '../../../views/admin/application-settings/models/data-attribute.model';

@Pipe({
    name: 'ngcAttributesFriendlyNameList'
})
export class AttributesFriendlyNameListPipe implements PipeTransform {

    transform(attributeList: DataAttribute[], quotationMarks = true): string {
        const list: string[] = attributeList?.map((attr: DataAttribute) => {
            const friendlyName = (attr.friendlyName || attr.propertyName);
            return quotationMarks ? `"${friendlyName}"` : friendlyName;
        });
        const last = list.pop();
        return list.join(', ')
            + (list.length > 0 ? ' and ' : '')
            + last;
    }
}
